import React, { useEffect, useMemo, useState } from "react";
import { Container } from "react-bootstrap";
import './Admin.css';
import { Link } from "react-router-dom";
import 'react-confirm-alert/src/react-confirm-alert.css';
import DataTable from "react-data-table-component";
import FilterComponent from "../Common/FilterComponent";
import TopHeader from "../Common/TopHeader";
import AppLoaderTable from "../Apploader/AppLoaderTable";
import { CheckPropertyExistOrNot, GetApiMethod } from "../../core/services/apiService";
import TooltipPositioned from "../Common/TooltipPositioned";

const AdminTable = () => {
    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [data, setData] = useState([]);
    const [showLoader, setShowLoader] = useState(true);

    const columns: any = [
        {
            name: 'Name',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'name'),
            sortable: true,

        },
        {
            name: 'Email',
            selector: (row: any) => CheckPropertyExistOrNot(row, 'email'),
            cell: (row: any) => TooltipPositioned({ position: 'top', item: CheckPropertyExistOrNot(row, 'email') }),
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row: any) => ((CheckPropertyExistOrNot(row, 'isActive') === true ? "Active" : (CheckPropertyExistOrNot(row, 'isActive') === false ? "Inactive" : "-"))),
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row: any) => (
                <div>
                    <Link to={'/super-admin/edit'} state={{ id: row._id, names: row.name, emails: row.email, is_active: row.isActive }}><i className="fa fa-edit text-primary" style={{ fontSize: 24, marginRight: 15 }}></i></Link>
                </div>
            )
        },

    ];

    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }
        };

        return (
            <FilterComponent
                onFilter={(e: any) => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

    const filteredItems = data.filter(
        (item: any) =>
            JSON.stringify([item.name, item.email, (item.isActive ? "Active" : "Inactive")])
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    useEffect(() => {
        GetApiMethod('admin/user/', { params: { role: 'super_admin' } }).then((res) => {
            setShowLoader(false);
            setData(res.data.data);
        });
    }, []);

    return (
        <>
            <Container fluid>
                <div className="mt-3">
                    <TopHeader
                        heading={"Super Admin"}
                        to={"/super-admin/create"}
                        className="fa-plus"
                        action="Add"
                        id="add-super-admin"
                    />

                    <DataTable
                        progressPending={showLoader}
                        progressComponent={<AppLoaderTable />}
                        columns={columns}
                        data={filteredItems}
                        pagination
                        paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        highlightOnHover
                        subHeader
                        persistTableHead
                        subHeaderComponent={subHeaderComponent}
                    />
                </div>
            </Container>
        </>
    )
}

export default AdminTable;